// DWS Blazor Component Library - theme before first paint (js/dws.theme.js, was DWSBlazorTheme.js).
//
// Put this script in the <head> of the host page (App.razor / index.html), before the stylesheets or right after
// them, WITHOUT defer or async:
//
//     <script src="_content/DWSBlazorComponentLibrary/js/dws.theme.js"></script>
//
// The theme service writes a theme as CSS variables on <html> once the Blazor runtime runs, and remembers those
// values in localStorage (core/theme.ts in js/dws.js). This script puts the remembered values back before anything is
// painted, so a reload - or a new tab - starts in the chosen theme instead of flashing the default palette first.
// The first visit on a device has nothing remembered and starts in the default palette, as before.
// It stays a separate, tiny, render-blocking script: it must run before the first paint, the core must not.

/** The storage key core/theme.ts writes (DWS_THEME_STORAGE_KEY there). */
const DWS_THEME_STORAGE_KEY = 'dws.theme.vars';

function restoreTheme(): void {
    try {
        const raw = window.localStorage.getItem(DWS_THEME_STORAGE_KEY);

        if (!raw) {
            return;
        }

        const values: unknown = JSON.parse(raw);
        const root = document.documentElement;

        if (!values || typeof values !== 'object') {
            return;
        }

        for (const name in values) {
            const value: unknown = (values as Record<string, unknown>)[name];

            // Only plain custom-property names and string values: this is data read back from storage.
            if (Object.prototype.hasOwnProperty.call(values, name) && /^[A-Za-z0-9_-]+$/.test(name) && typeof value === 'string') {
                root.style.setProperty('--' + name, value);
            }
        }

        root.setAttribute('data-dws-theme-restored', 'true');
    } catch (e) {
        // No storage, or something unreadable in it: the page starts in the default palette.
    }
}

restoreTheme();

// A module, so its names stay out of the global scope of the type check.
export { };
